const createDigitalCommerceCartClient = (httpClient) => {
  const config = {
    byPassGlobalErrorHandler: {
      404: true
    }
  }

  switch (process.env.APP_ENV) {
    case 'prDev':
      if (process.env.PR_NUMBER) config.baseURL = `https://wcdevelopment.telus.com/${process.env.PR_NUMBER}/commerce/bff`
      break
    case 'prStage': {
      const wwwPrefix = window.location.hostname.split('.')[0] === 'www' ? 'www.' : ''
      if (process.env.PR_NUMBER) config.baseURL = `https://${wwwPrefix}wcstage.telus.com/${process.env.PR_NUMBER}/commerce/bff`
      break
    }
    default:
      break
  }

  return {
    getCart: async () => {
      const res = await httpClient.get('/cart-overview', config)
      return { ...res, timestamp: Date.now() }
    },
    validateCart: () => {
      return httpClient.get('/cart-overview/validate', config)
    },
    removeItemsInCart: ({ items }) => {
      return httpClient.delete(
        '/cart-overview/items',
        {
          data: { items }
        },
        config
      )
    },
    resetCart: ({ language }) => {
      return httpClient.post(
        '/cart-overview/reset',
        { language },
        config
      )
    },
    getResolvingOffer: (cart) => {
      return httpClient.post(
        '/cart-overview/resolving-offer',
        {
          root: cart
        },
        config
      )
    },
    redeemCode: (code) => {
      return httpClient.post(
        '/cart-overview/redeem-code',
        {
          code
        },
        config
      )
    },
    removeCode: (code) => {
      return httpClient.delete(
        '/cart-overview/remove-code',
        {
          data: { code }
        },
        config
      )
    },
    updateItemFulfillment: ({ fulfillment, itemId }) => {
      return httpClient.patch(
        '/cart-overview/update-fulfillment',
        {
          fulfillment,
          itemId
        },
        config
      )
    },
    getFeatureFlags: () => httpClient.get('/cart-overview/feature-flags', config),
    getValueProps: (customerType, cartType) =>
      httpClient.get(`/cart-overview/value-props/${customerType}/${cartType}`, config),
    log: (payload) => {
      const { data, level } = payload

      if (data.message && data.meta) {
        return httpClient.post('/cart-overview/log', { data, level }, config)
      }

      throw new Error('Missing message and meta keys in logs')
    }
  }
}

export default createDigitalCommerceCartClient
